import { openImageInNewTab } from '../../../utils/imageHelpers';
import React, { useState } from "react";
import { X, ZoomIn } from "lucide-react";

/**
 * Professional image grid with preview and remove
 */
const ImageGrid = ({ images, onRemove }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-3">
          Uploaded Images ({images.length})
        </h4>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative group aspect-square rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Image */}
              <img
                src={image}
                alt={`Upload ${index + 1}`}
                className="w-full h-full object-cover"
              />

              {/* Overlay Actions */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center gap-2">
                {/* View Full Size */}
                <button
                  type="button"
                  onClick={() => openImageInNewTab(image, `Uploaded Image`)}
                  className="p-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
                  title="View full size"
                >
                  <ZoomIn className="w-5 h-5" />
                </button>

                {/* Remove */}
                <button
                  type="button"
                  onClick={() => onRemove(index)}
                  className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
                  title="Remove image"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Index Badge */}
              <div className="absolute top-2 left-2 px-2 py-1 bg-black/60 text-white text-xs font-medium rounded-md">
                {index + 1}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-5xl w-full">
            {/* Close Button */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Full Size Image */}
            <img
              src={selectedImage}
              alt="Full size preview"
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGrid;


